import React from 'react';

interface WatermarkProps {
  isPremium?: boolean;
  hasPartnerAttribution?: boolean;
  themeBgColor?: string | null;
}

function isDarkColor(colorHex: string | null | undefined): boolean {
  if (!colorHex) return false;
  const hex = colorHex.replace('#', '');
  if (hex.length === 3) {
    const r = parseInt(hex[0] + hex[0], 16);
    const g = parseInt(hex[1] + hex[1], 16);
    const b = parseInt(hex[2] + hex[2], 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq < 128;
  }
  if (hex.length === 6) {
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq < 128;
  }
  return false;
}

export function Watermark({ isPremium, hasPartnerAttribution, themeBgColor }: WatermarkProps) {
  if (isPremium) return null;

  const isDark = themeBgColor ? isDarkColor(themeBgColor) : false;

  if (hasPartnerAttribution) {
    return (
      <div data-watermark className="w-full py-6 flex items-center justify-center bg-transparent select-none border-t border-outline-variant/10" data-no-print>
        <span className={`text-[10px] font-medium tracking-wider uppercase ${isDark ? 'text-white/30' : 'text-on-surface-variant/40'}`}>
          © {new Date().getFullYear()}
        </span>
      </div>
    );
  }

  return (
    <div data-watermark className="w-full py-6 flex items-center justify-center bg-transparent select-none border-t border-outline-variant/10">
      <a
        href="https://invitecloud.in"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-1.5 px-3 py-1.5 rounded-full hover:bg-surface-low transition-all duration-300 pointer-events-auto"
      >
        <span className="text-[11px] font-medium tracking-wider uppercase text-on-surface-variant/60 group-hover:text-on-surface-variant transition-colors duration-300">
          Made with
        </span>
        <span className="text-xs font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent group-hover:opacity-80 transition-opacity duration-300">
          InviteCloud.in
        </span>
      </a>
    </div>
  );
}
